export default __webpack_public_path__ + "static/media/Twitter.11d26530.svg";